import { Component, OnInit } from '@angular/core';
import { SimulationDefault } from '../../models/simulation';

@Component({
    selector: 'simulation-activity-defaults',
    templateUrl: './activity-defaults.component.html',
    styleUrls: ['../job-simulator/job-simulator.component.css'],
    standalone: false
})
export class ActivityDefaultsComponent implements OnInit {
  //@Output() defaultsChanged = new EventEmitter();
  
  defaults: SimulationDefault = {};
  
  constructor() { }

  ngOnInit() {
  }

  /* Send an event of the configuration change */
  // onDefaultsChange() {
  //   this.defaultsChanged.emit();
  // }
}
